import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../../../../shared/components/LoadingOverlay';
import taskGroupsActions from '../../../store/task-groups/action-creators';
import taskGroupsSelectors from '../../../store/task-groups/selectors';
import CloseActionButton from '../../common/CloseActionButton';
import TaskForm from './TaskForm';

class TaskGroupTaskAdd extends Component {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.match.params.taskGroupGuid !== this.props.selectedGuid) {
      this.props.setSelectedTaskGroup(this.props.match.params.taskGroupGuid);
    }
  }

  // ----------------------
  // Handlers
  // ----------------------

  onClose() {
    if(this.props.userContext.hasScope('admin')) {
      const url = `/admin/task-groups/${this.props.match.params.taskGroupGuid}`;
      this.props.history.push(url);
    } else {
      const url = `/task-groups/${this.props.match.params.taskGroupGuid}`;
      this.props.history.push(url);
    }

  }

  onSave(properties) {
    const formData = {
      ...properties,
      taskGroupGuid: this.props.selectedGuid,
    };
    this.props.addTaskToTaskGroup(formData).then(() => this.onClose());
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return !this.props.selectedTaskGroup;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">
                {this.props.selectedTaskGroup.name}: Add Task
              </h4>
              <CloseActionButton label="Add Task" onClose={this.onClose} />
            </div>
            <div className="app-content">
              <TaskForm
                isLoading={this.props.isLoading}
                onSave={this.onSave}
              />
            </div>
          </Fragment>
        )}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    selectedGuid: state.taskGroups.selectedGuid,
    selectedTaskGroup: taskGroupsSelectors.selectedTaskGroup(state),
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addTaskToTaskGroup: formData =>
      dispatch(taskGroupsActions.addTaskToTaskGroup(formData)),
    setSelectedTaskGroup: (taskGroupGuid) => {
      return dispatch(taskGroupsActions.setSelectedTaskGroup(taskGroupGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupTaskAdd);
